<template>
    <el-container class="outer">
      <div class="loginContainer">
        <el-card>
          <div class="title">{{ $t('LOGIN_loginTitle') }}</div>
  
          
          <transition name="fade" mode="out-in">
            <!-- FORMULARIO LOGIN -->
            <el-form key="newUserForm" :model="newUserForm">
              <el-form-item :error="newUserErrors['usuario']" class="custom-error">
                <el-input
                  :placeholder="$t('LOGIN_user')"
                  prefix-icon="User"
                  v-model="newUserForm.usuario"
                />
              </el-form-item>
  
              <el-form-item :error="newUserErrors['contrasenia']" class="custom-error">
                <el-input
                  :placeholder="$t('LOGIN_password')"
                  prefix-icon="Lock"
                  show-password
                  v-model="newUserForm.contrasenia"
                />
              </el-form-item>

              <el-form-item :error="newUserErrors['confirmarContrasenia']" class="custom-error">
                <el-input
                  :placeholder="$t('LOGIN_confirm_password')"
                  prefix-icon="Lock"
                  show-password
                  v-model="newUserForm.confirmarContrasenia"
                  @keyup.enter="onGuardarContrasenia"
                />
              </el-form-item>
  
              <el-form-item class="botonContainer">
                <el-button
                  v-on:click="onGuardarContrasenia"
                  :loading="sesion.loading"
                  plain
                  type="primary"
                  style=" color:white !important;"
                >{{ $t('LOGIN_saveBtn') }}</el-button>
              </el-form-item>
            </el-form>
        </transition>
  
          <div class="footer">
            <div class="dataFiscalContainer">
              <a href="http://qr.afip.gob.ar/?qr=2fGI8DEy48NDM7k_CLFtdg,," target="_blank">
                <img src="../../images/dataFiscal.png" />
              </a>
            </div>
  
            <div class="contactoContainer">
              <router-link :to="{ name: 'Info' }">
                <el-link style="color:white;">
                  <el-icon><Message /></el-icon>
                  {{ $t('LOGIN_contact') }}
                </el-link>
              </router-link>
            </div>
          </div>
        </el-card>
    </div>  
    </el-container>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import { showError, showSuccess } from "../Mensaje";
  
  export default {
    name: "NewUser",
    data() {
      return {
        newUserForm: {
          usuario: "",
          contrasenia: "",
          confirmarContrasenia:""
        },
        newUserErrors: {},
      };
    },
    methods: {
      onGuardarContrasenia() {
        //Scroll para Android
        document.body.scrollTop = 0;
        //Scroll para IOS
        document.documentElement.scrollTop = 0;
        if (this.sesion.loading) return;
  
        // valido el formulario
        let valida = true;
        this.newUserErrors = {};
  
        if (!this.newUserForm.usuario) {
          valida = false;
          this.newUserErrors["usuario"] = this.$t("GENERAL_requiredField");
        }
  
        if (!this.newUserForm.contrasenia) {
          valida = false;
          this.newUserErrors["contrasenia"] = this.$t("GENERAL_requiredField");
        }

        if (!this.newUserForm.confirmarContrasenia) {
          valida = false;
          this.newUserErrors["confirmarContrasenia"] = this.$t("GENERAL_requiredField");
        }
        else if (this.newUserForm.confirmarContrasenia !== this.newUserForm.contrasenia) {
          valida = false;
          this.newUserErrors["confirmarContrasenia"] = this.$t("CHANGE_PASS_passwordNotEquals");
        }
  
        if (!valida) return;
  
        // autentico el usuario
        let payload = {
          usuario: this.newUserForm.usuario,
          contrasenia: this.newUserForm.contrasenia
        };
        this.$store.dispatch("sesion/guardarContrasenia", payload).then(response => {
          if (response !== undefined) {
            // si está autenticado redirijo al login
            if (response.data === 0){
                showSuccess(this.$t("NEW_USER_savePassordSuccess"));
                this.newUserForm = {
                    usuario: "",
                    contrasenia: "",
                    confirmarContrasenia:"",
                };
                this.$router.push({ name: "Login" }); 
            }
              
            else if(response.data === 2) showError(this.$t("NEW_USER_invalidUser"));
            else if(response.data === 8) showError(this.$t("ERROR_CODE_AUTH_8"));
            else if(response.data === 9) showError(this.$t("NEW_USER_userExists"));
            else if(response.data === 10) showError(this.$t("ERROR_CODE_AUTH_10"));
            else if(response.data === 12) showError(this.$t("ERROR_CODE_AUTH_12"));
            else showError(this.$t("LOGIN_invalidLogin"));
          } else showError(this.$t("ERROR_CODE_NETWORK"));
        });
      },
    },
    computed: mapState({
      sesion: state => state.sesion
    })
  };
  </script>
  
  <style scoped>
  .el-card {
    border-top: 4px solid white !important;
    background-color: var(--main-color) !important;
    box-shadow: 0px 0px 7px grey;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    transition: opacity 0.3s ease;
  }
  .fade-leave-active {
    transition: opacity 0.3s ease;
    opacity: 0;
  }
  .el-container.outer {
    display: table;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  
  .loginContainer {
    display: table-cell;
    vertical-align: middle;
  }
  
  .loginContainer .el-card {
    margin-left: auto;
    margin-right: auto;
    width: 80% !important;
    max-width: 690px !important;
  }
  
  div.title {
    font-size: 30px;
    line-height: 35px;
    text-align: center;
    color: white;
  }
  
  .el-form {
    padding: 40px 100px 0px 100px;
  }
  
  .el-button {
    width: 100%;
  }
  
  .botonContainer {
    margin-bottom: 10px;
  }
  
  .mensajeError {
    background-color: #f44336;
    color: white;
    line-height: 22px;
  }
  
  .el-form .el-link {
    font-weight: bold;
    text-decoration: underline;
  }
  
  .footer {
    display: inline-block;
    width: 100%;
  }
  
  .dataFiscalContainer {
    float: left;
  }
  
  .contactoContainer {
    float: right;
    padding-top: 35px;
    color: white;
  }
  
  .contactoContainer .el-link i {
    margin-right: 10px;
    color: white;
  }
  
  .el-radio-group {
    text-align: left;
    width: 100%;
  }
  
  .el-radio {
    float: left;
    margin-bottom: 5px;
  }
  
  .restablecerMessage {
    margin: 0px;
    margin-bottom: 15px;
    font-size: 14px;
    text-align: left;
  }
  
  .resetPassword .usuarioLabel {
    text-align: left;
    color: white;
    font-weight: bold;
  }

  .custom-error .el-form-item__error {
    color: white !important; /* Cambia el color a blanco */
  }

  
  @media (max-width: 750px) {
    .el-form {
      padding: 20px 20px 0px 20px;
    }
  
    .botonContainer button.first {
      margin-bottom: 10px;
    }
  }
  </style>
  
  <style>
  .el-form.resetPassword .el-form-item__content {
    line-height: 22px;
  }
  </style>